import { createApp } from 'vue'
import extend from 'just-extend'

import VueApexCharts from 'vue3-apexcharts'

import App from './App.vue'
import router from './router'
import store from './store'

import './registerServiceWorker'
import './assets/tailwind.css'
import './assets/ui.scss'

const VueApp = createApp(App)
VueApp.use(store)
VueApp.use(router)
VueApp.use(VueApexCharts)

if (typeof window !== 'undefined') {
  if (window.__INITIAL_STATE__) {
    store.replaceState(extend({}, store.state, window.__INITIAL_STATE__))
  }
}

store.commit('ON_CLIENT_INIT')
/*
watch(
  () => store.getters.ready,
  (ready) => (ready ? checkRouteRolesRedirect(router.currentRoute.value) : undefined)
)
*/

router.isReady().then(() => {
  // We initialize the store state with the data injected from backend
  VueApp.mount('#app')
})
